import { render, staticRenderFns } from "./EditDiscussion.vue?vue&type=template&id=fd75e05c&scoped=true"
import script from "./EditDiscussion.vue?vue&type=script&lang=js"
export * from "./EditDiscussion.vue?vue&type=script&lang=js"
import style0 from "./EditDiscussion.vue?vue&type=style&index=0&id=fd75e05c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd75e05c",
  null
  
)

export default component.exports